var map = {
	"./symbol_0.png": 27521,
	"./symbol_1.png": 42904,
	"./symbol_10.png": 17226,
	"./symbol_11.png": 49139,
	"./symbol_12.png": 37176,
	"./symbol_2.png": 33747,
	"./symbol_3.png": 78538,
	"./symbol_4.png": 63205,
	"./symbol_5.png": 33788,
	"./symbol_6.png": 34423,
	"./symbol_7.png": 91406,
	"./symbol_8.png": 64441,
	"./symbol_9.png": 83888
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50588;